import React, { useEffect, useState } from 'react';
import {
    Table, TableBody, TableHead, TableRow, TableCell, Typography, Grid, Card, Chip, CircularProgress, Box, styled, TextField, Button
} from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import axios from './../../axios/api';

const StyledTablePagination = styled(TablePagination)(({ theme }) => ({
    '& .MuiTablePagination-actions .Mui-disabled': {
        color: '#ccc',
    },
    '& .MuiTablePagination-actions': {
        color: 'rgba(0, 0, 0, 0.54)'
    },
}));

const UsersPage = () => {
    console.log('UsersPage rendered');
    const [Data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalResults, setTotalResults] = useState(0);
    const [nameFilter, setNameFilter] = useState('');
    const [phoneFilter, setPhoneFilter] = useState('');

    useEffect(() => {
        GetData();

    }, [page, rowsPerPage]); // Include nameFilter and phoneFilter in dependencies




    const GetData = async (resetPage = false) => {
        if (resetPage) setPage(1);
        try {
            setIsLoading(true);
            let url = `/admin/user?is_paginate=true&count_of_page=${rowsPerPage}`;
            if (nameFilter) url += `&search=${nameFilter}`;
            if (phoneFilter) url += `&mobile=${phoneFilter}`;
            const res = await axios.get(`${url}&page=${resetPage ? 1 : page}`);
            setData(res.data?.data?.data?.data);
            setTotalResults(res.data?.data?.data?.total);
        } catch (e) {
            console.log(e.response, "eeeeeeeee");
        } finally {
            setIsLoading(false);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage + 1);  // Adjusting for the server's 1-based index
    };

    const handleFilter = () => {
        GetData(true);
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleFilter();
        }
    };

    return (
        <Grid container spacing={2} sx={{ direction: 'ltr' }}>
            <Grid item xs={12} lg={12}>
                <Card variant="outlined">
                    <Grid container spacing={2} sx={{ marginBottom: 2 }}>
                        <Grid item lg={5} md={5} sm={12}>
                            <TextField
                                label="نام"
                                placeholder='جستجو براساس نام یا فامیل'
                                fullWidth
                                value={nameFilter}
                                onKeyDown={handleKeyDown}
                                onChange={(e) => setNameFilter(e.target.value)}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item lg={5} md={5} sm={12}>
                            <TextField
                                label="شماره تماس"
                                placeholder='09133333333'
                                fullWidth
                                onKeyDown={handleKeyDown}
                                value={phoneFilter}
                                onChange={(e) => setPhoneFilter(e.target.value)}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item lg={2} md={2} sm={12}>
                            <Button
                                onClick={handleFilter}
                                sx={{ padding: '16.5px 14px' }}
                                color="secondary"
                                fullWidth
                                variant="contained"
                                size="large"
                            >
                                <Typography color="white">فیلتر</Typography>
                            </Button>
                        </Grid>
                    </Grid>

                    {isLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <>
                            {Data.length === 0 ? (
                                <Typography variant="h6" color="textSecondary" align="center" sx={{ p: 2 }}>
                                    داده‌ای وجود ندارد
                                </Typography>
                            ) : (
                                <>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ textAlign: 'center' }}>
                                                    <Typography color="textSecondary" variant="h6">
                                                        نام
                                                    </Typography>
                                                </TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>
                                                    <Typography color="textSecondary" variant="h6">
                                                        نام خانوادگی
                                                    </Typography>
                                                </TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>
                                                    <Typography color="textSecondary" variant="h6">
                                                        شماره تماس
                                                    </Typography>
                                                </TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>
                                                    <Typography color="textSecondary" variant="h6">
                                                        وضعیت
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Data.map((character) => (
                                                <TableRow key={character.id}>
                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        <Typography variant="body2">{character?.name ? character?.name : "-"}</Typography>
                                                    </TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        <Typography variant="body2">{character?.family ? character?.family : "-"}</Typography>
                                                    </TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        <Typography variant="body2">{character.mobile}</Typography>
                                                    </TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        <Chip label={character?.active_plan_days ? character?.active_plan_days : "غیرفعال"} color={character?.active_plan_days ? "success" : "error"} />
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    <StyledTablePagination
                                        component="div"
                                        count={totalResults}
                                        rowsPerPage={rowsPerPage}
                                        page={page - 1}  // Adjusting for the 0-based index of TablePagination
                                        onPageChange={handleChangePage}
                                        rowsPerPageOptions={[]} // Hide rows per page dropdown
                                        labelRowsPerPage="" // Hide label
                                        showFirstButton
                                        showLastButton
                                    />
                                </>
                            )}
                        </>
                    )}
                </Card>
            </Grid>
        </Grid>
    );
};

export default UsersPage;
